import { Component } from '@angular/core';

@Component({
  selector: 'app-organizations-section',
  imports: [],
  templateUrl: './organizations-section.html',
  styleUrl: './organizations-section.css',
})
export class OrganizationsSection {
  organizations = Array(5);
}
